module.exports = __webpack_public_path__ + "img/img19.754a7973.svg";